
$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.25;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }else{
          This.removeClass('active');
        }
    });
  });

  $('.fan_row_right .fan_btn').click(function(){
    $(this).parents('.fan_block').toggleClass('open');
    if ($(this).children('span').html()=='閉じる ▲') {
      $(this).children('span').html('詳細を見る ▼');
    }else if ($(this).children('span').html()=='詳細を見る ▼') {
      $(this).children('span').html('閉じる ▲');
    }
  });
  $('.faq_head').click(function(){
    $(this).parents('.faq_block').toggleClass('open');
  });

  $('.header_menu_btn,.header_menu a').click(function(){
    $('header').toggleClass('open');
  });

  $('.modal_open').click(function(){
    var modalNum = $(this).data('modal');
    var modalId = "modal-"+modalNum;
    $('#'+modalId).addClass('open');
    console.log(modalId);
  });
  $('.modal_bg,.modal_close').click(function(){
    $(this).parents('.modal_wrapper').removeClass('open');
  });

});
